import {createSelector, MemoizedSelector} from '@ngrx/store';
import {ClubLogo} from '@app/rest-client/faxe/models/club-logo';
import {getClubLogoState} from '@app/store/faxe/faxe-selectors';
import {selectAllClubLogo} from '@app/store/faxe/club-logo/club-logo.reducer';


export const selectClubLogoAll: MemoizedSelector<object, ClubLogo[]> = createSelector(
  getClubLogoState,
  selectAllClubLogo
);

export const selectClubLogo = ():
  MemoizedSelector<object, ClubLogo[]> =>
  createSelector(
    getClubLogoState,
    selectClubLogoAll,
    (state, all) => all
  );



